import { defaultBillingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

defaultBillingAddressStyles.headingText = {
        variant: "h5",
        css: css`
            margin-bottom: 0;
            color: ${getColor("text.main")};
        `,
}
defaultBillingAddressStyles.editLink ={
    css: css`
    margin-left: 10px;
    > span {
        &:hover {
            text-decoration-line: underline;
            color: ${getColor("text.link")};
        }
    }
    `,
}
defaultBillingAddressStyles.addressInfoDisplayGridItem = {
    width: 12,
    css: css`
    color: ${getColor("text.main")};
`,
}
